import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService.js';

interface AdminGuardProps {
  children: React.ReactNode;
}

const AdminGuard = ({ children }: AdminGuardProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Kiểm tra xem user có đăng nhập và có quyền admin không
    if (!authService.hasAdminAccess()) {
      navigate('/unauthorized');
    }
  }, [navigate]);

  // Nếu không có quyền, không render children
  if (!authService.hasAdminAccess()) {
    return null;
  }

  return <>{children}</>;
};

export default AdminGuard;
